"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskEvent = exports.TaskEventType = void 0;
var TaskEventType;
(function (TaskEventType) {
    TaskEventType["ChangeStatus"] = "task:change-status";
})(TaskEventType = exports.TaskEventType || (exports.TaskEventType = {}));
class TaskEvent extends CustomEvent {
    constructor(type, eventInitDict) {
        super(type, eventInitDict);
    }
    static dispatch(type, data) {
        console.debug('[TaskEvent] dispatch:', type, data);
        const event = new this(type, { detail: data });
        document.dispatchEvent(event);
        return event;
    }
    static handle(type, callback) {
        console.debug('[TaskEvent] handle:', type);
        const listener = event => {
            const data = event.detail;
            console.debug('[TaskEvent] listener: %s, data: %o', type, data);
            callback(data);
        };
        document.addEventListener(type, listener);
        return () => {
            console.debug('[TaskEvent] remove:', type);
            document.removeEventListener(type, listener);
        };
    }
}
exports.TaskEvent = TaskEvent;
//# sourceMappingURL=Task.event.js.map